/**
 * Avatar tint palette — documented DS exception.
 *
 * Per Figma 32:580, raw hex values aren't allowed in component code. This
 * file violates that rule deliberately: avatar tints encode decorative
 * variety (which user is this?), not semantic meaning, and have no DS
 * palette equivalent. The decision to keep this as a case-by-case
 * exception — rather than publish a formal `decorative/*` DS tier — was
 * recorded on #1693 / #1694 E.4.
 *
 * The 8 stops below were tuned for white-on-color initial contrast and
 * have been stable since launch. Coordinate with design before adding
 * stops or retuning. If a DS `decorative/*` tier is ever published, this
 * file migrates to it.
 */

const AVATAR_COLORS = [
  '#7a9cc6', // Muted blue (from logo)
  '#8ba68f', // Muted sage green
  '#a98d9e', // Muted mauve
  '#c4735a', // Muted coral (from logo)
  '#9b8fb5', // Muted lavender
  '#8aa8a0', // Muted teal
  '#b89a6f', // Muted tan
  '#c28a8a', // Muted rose
];

const AVATAR_COLOR_CLASSES = [
  'bg-[#7a9cc6]',
  'bg-[#8ba68f]',
  'bg-[#a98d9e]',
  'bg-[#c4735a]',
  'bg-[#9b8fb5]',
  'bg-[#8aa8a0]',
  'bg-[#b89a6f]',
  'bg-[#c28a8a]',
];

function hashString(text: string): number {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

/**
 * Get the avatar color as a hex value
 */
export function getAvatarColorHex(displayName: string, email: string): string {
  const text = displayName || email || 'user';
  const hash = hashString(text);
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]!;
}

/**
 * Get the avatar color as a Tailwind class
 */
export function getAvatarColorClass(displayName: string, email: string): string {
  const text = displayName || email || 'user';
  const hash = hashString(text);
  return AVATAR_COLOR_CLASSES[hash % AVATAR_COLOR_CLASSES.length]!;
}
